import { FunctionComponent, PropsWithChildren } from 'react'
import { LinearProgress } from '@mui/material'
import DashboardBreadcrumbs from '@pages/Dashboard/components/DashboardBreadcrumbs'
import DashboardHeader from '@pages/Dashboard/components/DashboardHeader'
import DashboardNavigation from '@pages/Dashboard/components/DashboardNavigation'
import styles from '../dashboard.module.css'

type Props = {
    loading?: boolean
    hideBreadcrumbs?: boolean
    /** Names the last breadcrumb — see `DashboardBreadcrumbs`. */
    breadcrumbLabel?: string | null
}

const DashboardLayout: FunctionComponent<PropsWithChildren<Props>> = (
    props
) => {
    return (
        <div>
            <DashboardHeader />
            <div className={styles.bodyAndNavContainer}>
                <div className={styles.navContainer}>
                    <DashboardNavigation />
                </div>
                <div className={styles.contentOuter}>
                    <div className={styles.loadingBarContainer}>
                        {props.loading && <LinearProgress />}
                    </div>
                    <div className={styles.contentInner}>
                        {!props.hideBreadcrumbs && (
                            <DashboardBreadcrumbs
                                currentLabel={props.breadcrumbLabel}
                            />
                        )}
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardLayout
